import { shouldPreload, getPreloadDelay } from './networkDetection';

// Utility to preload pages based on user role for better performance
export const preloadPagesByRole = (roleName: string) => {
  if (!shouldPreload()) {
    console.log('Preloading disabled due to network conditions');
    return;
  }
  // Preload critical pages based on user role
  switch (roleName) {
    case 'admin':
    case 'super_admin':
      // Preload admin-critical pages
      import('../pages/DashboardPage');
      import('../pages/ClientsPage');
      import('../pages/ProjectsPage');
      import('../pages/EmployeesPage');
      import('../pages/AdminAssignmentsPage');
      import('../pages/InvoicesPage');
      import('../pages/BrandSettingsPage');
      break;
      
    case 'designer':
      // Preload designer-critical pages
      import('../pages/DashboardPage');
      import('../pages/ClientsPage');
      import('../pages/ProjectsPage');
      import('../pages/MeasurementsPage');
      import('../pages/VirtualFittingPage');
      break;
      
    case 'employee':
      // Preload employee-critical pages
      import('../pages/EmployeeDashboardPage');
      import('../pages/ProjectsPage');
      break;
      
    default:
      // Preload basic pages for unknown roles
      import('../pages/DashboardPage');
      break;
  }
};

// Preload commonly accessed pages
export const preloadCommonPages = () => {
  if (!shouldPreload()) {
    console.log('Common page preloading disabled due to network conditions');
    return;
  }
  
  // These pages are frequently accessed across all user types
  const delay = getPreloadDelay();
  setTimeout(() => {
    import('../pages/DashboardPage');
    import('../pages/ClientsPage');
  }, delay);
};

// Preload pages on hover (for navigation)
export const preloadPageOnHover = (pageName: string) => {
  if (!shouldPreload()) {
    return; // Silently skip hover preloading on slow connections
  }
  switch (pageName) {
    case 'dashboard':
      import('../pages/DashboardPage');
      break;
    case 'clients':
      import('../pages/ClientsPage');
      break;
    case 'projects':
      import('../pages/ProjectsPage');
      break;
    case 'measurements':
      import('../pages/MeasurementsPage');
      break;
    case 'employees':
      import('../pages/EmployeesPage');
      break;
    case 'assignments':
      import('../pages/EmployeeDashboardPage');
      break;
    case 'virtual-fitting':
      import('../pages/VirtualFittingPage');
      break;
    case 'invoices':
      import('../pages/InvoicesPage');
      break;
    case 'brand-settings':
      import('../pages/BrandSettingsPage');
      break;
    case 'time-reports':
      import('../pages/TimeReportsPage');
      break;
    case 'attendance':
      import('../pages/AttendanceDashboardPage');
      break;
    default:
      break;
  }
}; 